var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"scene",attrs:{"id":"scene-4"}},[_c('ImageFloat',{staticClass:"booklet",class:{
      'fix-me': _vm.activeElements['booklet'] === 'fixed',
      'end': _vm.activeElements['booklet'] === 'end'
    },attrs:{"id":"booklet"}}),_c('div',{staticClass:"triggers",attrs:{"id":"trigger-9-1"}}),_c('Why',{staticClass:"why",class:{
      'fix-me': _vm.activeElements['why-mock'] === 'fixed',
      'end': _vm.activeElements['why-mock'] === 'end'
    },attrs:{"id":"why-mock"}}),_c('div',{staticClass:"triggers",attrs:{"id":"trigger-9-2"}}),_c('div',{staticClass:"triggers",attrs:{"id":"trigger-9"}}),_c('div',{staticClass:"triggers",attrs:{"id":"trigger-10"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }